"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClientWithAuth = exports.cognitoAuthLink = void 0;
var client_1 = require("@apollo/client");
var batch_http_1 = require("@apollo/client/link/batch-http");
var context_1 = require("@apollo/client/link/context");
var retry_1 = require("@apollo/client/link/retry");
var ws_1 = require("@apollo/client/link/ws");
var utilities_1 = require("@apollo/client/utilities");
var auth_utils_1 = require("../auth/auth-utils");
function cognitoAuthLink() {
    var _this = this;
    return (0, context_1.setContext)(function (op, prevContext) { return __awaiter(_this, void 0, void 0, function () {
        var token, Authorization;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, auth_utils_1.currentAuthToken)()];
                case 1:
                    token = _a.sent();
                    Authorization = token ? "Bearer ".concat(token) : undefined;
                    return [2 /*return*/, __assign({ headers: { Authorization: Authorization } }, prevContext)];
            }
        });
    }); });
}
exports.cognitoAuthLink = cognitoAuthLink;
function createApolloClientWithAuth(uri, options) {
    // http link
    var httpLinkType = options.batchHttpLinkOptions
        ? new batch_http_1.BatchHttpLink(__assign({ uri: uri }, options.batchHttpLinkOptions))
        : (0, client_1.createHttpLink)(__assign({ uri: uri }, options.httpLinkOptions));
    // web socket link
    var maybeWsLink = options.useWebSockets
        ? new ws_1.WebSocketLink({
            uri: uri.replace(/^http(s?)/, "ws$1"),
            options: { reconnect: true },
        })
        : undefined;
    // split links; use web sockets for subscriptions, http for queries, mutations
    var maybeSplitLink = maybeWsLink
        ? (0, client_1.split)(function (_a) {
            var query = _a.query;
            var definition = (0, utilities_1.getMainDefinition)(query);
            return definition.kind === "OperationDefinition" && definition.operation === "subscription";
        }, maybeWsLink, httpLinkType)
        : httpLinkType;
    // Include a retry link, if it is configured
    var maybeRetryLink = options.retryLinkOptions ? new retry_1.RetryLink(options.retryLinkOptions) : undefined;
    // merge in cognito link
    var link = client_1.ApolloLink.from([cognitoAuthLink(), maybeRetryLink, maybeSplitLink].filter(function (l) { return !!l; }));
    return new client_1.ApolloClient(__assign({ link: link, cache: new client_1.InMemoryCache(options.inMemoryCacheOptions) }, options.apolloClientOptions));
}
exports.createApolloClientWithAuth = createApolloClientWithAuth;
//# sourceMappingURL=graphql-client.js.map